// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes svg_dash_animate {\n100% {\n    stroke-dashoffset: 0;\n}\n}\n.linker {\n  display: block;\n  text-decoration: none;\n}\n.linker .linker__image {\n  width: 100%;\n}\n.linker .linker__image > img {\n  width: 100%;\n  height: auto;\n  vertical-align: top;\n}\n", ""]);
// Exports
module.exports = exports;
